import { countryList } from "@/locales/properNouns";
import messages from "./json/es.json";

export default {
  pl: {
    word: "{n} {word} | {n} {word}s",
  },
  notificationsText: {
    liked: "A {screenName} le ha gustado tu publicación",
    followed: "{screenName} te ha seguido",
    subscribed: "{screenName} se suscribió a ti por {price}",
    upgradeSubscription: "{screenName} actualizó la suscripción contigo. Ahora el nivel de suscripción es {price}",
    soldPost: "{screenName} compró tu publicación por {price}",
    soldAttachment: "{screenName} compró tu adjunto por {price}",
    soldEvent: "{screenName} ha reservado tu evento {date} por {price}",
    eventPublished: "¡Próximo evento por {screenName}!",
    eventStarted: "El evento ha comenzado",
    eventCancelled: "{screenName} canceló el evento",
  },
  ...messages,
  ...countryList,
};
